import { collectChapters, distributeChapters } from './updatePhaseDetails';
import { addEmptyWeeks } from './emptyWeeksToNewMilestone';
import updateWeekNumbers from './updateWeekNumbers';
import moment from 'moment';
import { distributeMainAndExtraTests } from '../../CreateNewCourse/mergingTrees';

export const addNewMilestone = (tree: any, setTreeData: Function, parentNode: any, newMilestone: any) => {
  
  const cloneTree = JSON.parse(JSON.stringify(tree));
  const { phases } = cloneTree;
  const currentPhase = phases[parentNode.phaseIndex];
  const currentPhaseExtraTests = currentPhase.extraTests;
  currentPhase.extraTests = [];
  const newPhase = getNewPhase(currentPhase, newMilestone);

  if (parentNode.key === 'week') {
    let currentWeeks = currentPhase.weeks;
    phases.splice(parentNode.phaseIndex + 1, 0, newPhase);
    updatePhaseIndex(phases);

    if (newPhase.isRevision) {
      newPhase.weeks = [];
      addEmptyWeeks(cloneTree, newPhase);
      const syllabus = collectChapters(currentPhase.weeks);
      currentWeeks.splice(parentNode.weekIndex);
      currentPhase.endDate = currentWeeks[currentWeeks.length - 1].endDate;
      // redistribute chapters
      distributeChapters(currentPhase.weeks, syllabus);
    }

    if (!newPhase.isRevision) {
      newPhase.weeks = currentWeeks.slice(parentNode.weekIndex);
      currentPhase.weeks = currentWeeks.slice(0, parentNode.weekIndex);
      currentPhase.endDate = currentWeeks[currentWeeks.length - 1].endDate;
      // collect syllabus
      const syllabus = collectChapters(newPhase.weeks);
      // remove old weeks
      newPhase.weeks = [];
      // add correct number of weeks
      addEmptyWeeks(cloneTree, newPhase);
      // redistribute chapters
      distributeChapters(newPhase.weeks, syllabus);

      rebuildSubjectsArray(newPhase);
      rebuildSubjectsArray(currentPhase);
    }
  }

  if (parentNode.key === 'phase') {
    phases.splice(parentNode.phaseIndex, 0, newPhase);
    updatePhaseIndex(phases);
    newPhase.weeks = [];
    addEmptyWeeks(cloneTree, newPhase);
    // if (!newPhase.isRevision) {
    //   cloneTree.totalPhases += 1;
    // }
  }

  if (parentNode.key === 'week') {
    const { weeks } = currentPhase;
    const lastWeek = weeks[weeks.length - 1];
    currentPhase.endDate = new Date(lastWeek.endDate);
  }
  updateWeekNumbers(phases);
  const clonedTree = JSON.parse(JSON.stringify(cloneTree));
    
  clonedTree.totalPhases += 1;

  distributeMainAndExtraTests(currentPhaseExtraTests, clonedTree.phases)

  setTreeData({ treeData: clonedTree  });
};

const getNewPhase = (currentPhase: any, newMilestone: any) => {

  const newPhase = { ...currentPhase, ...newMilestone };
  newPhase.milestoneTests = [];
  newPhase.subjects = [];
  delete newPhase._id;
  newPhase.children = [];
  newPhase.endDate = moment(newPhase.endDate).format('YYYY-MM-DD HH:MM:SS');
  return newPhase;
};

const updatePhaseIndex = (clonePhases: any) => {
  clonePhases.forEach((phase: any, index: number) => {
    phase.phaseIndex = index;
  });
};

export const rebuildSubjectsArray = (phase: any) => {
  phase.subjects = [];

  for (const week of phase.weeks) {
    for (const subject of week.subjects) {
      let index = getIndex(phase, subject.name);
      if (index === -1) {
        phase.subjects.push({
          name: subject.name,
          id: subject.id,
          chapterCount: subject.chapters.length,
        });
      } else {
        phase.subjects[index].chapterCount += subject.chapters.length;
      }
    }
  }
};

const getIndex = (phase: any, subjectName: string) => {
  const subjects = phase.subjects;
  const len = subjects.length;
  if (len) {
    for (let i = 0; i < len; i++) {
      if (subjects[i].name === subjectName) {
        return i;
      }
    }
  }
  return -1;
};
